export const validation_dict = {
  en: {
    messages: {
      required: () => 'is required',
      email: () => 'is not valid',
      regex: () => 'is not valid',
      is_not: () => 'is not valid'
    },
    custom: {
      email: {
        regex: () => "can't be a free provider"
      },
      password_confirm: {
        confirmed: () => "doesn't match"
      }
    }
  },
  es: {
    messages: {
      required: () => 'es requerido',
      email: () => 'no es valida',
      regex: () => 'no es valida',
      is_not: () => 'no es valida'
    },
    custom: {
      email: {
        regex: () => "can't be a free provider"
      },
      password_confirm: {
        confirmed: () => "no coincide"
      }
    }
  },
  'pt-br': {
    messages: {
      required: () => 'é necessário',
      email: () => 'não é válida',
      regex: () => 'não é válida',
      is_not: () => 'não é válida',
    },
    custom: {
      email: {
        regex: () => "can't be a free provider"
      },
      password_confirm: {
        confirmed: () => "não corresponde"
      }
    }
  },
  nl: {
    messages: {
      required: () => 'is verplicht',
      email: () => 'is ongeldig',
      regex: () => 'is ongeldig',
      is_not: () => 'is ongeldig'
    },
    custom: {
      email: {
        regex: () => "kan geen gratis aanbieder zijn"
      },
      password_confirm: {
        confirmed: () => "komt niet overeen"
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/i18n/validation.js